import React from 'react'
import { Checkbox } from 'antd'

const BulkSelect = (props) => {
    const {isSelectedAll, selectedItems, loadingSend} = props

    const _handleChange = () => {
        props.toggleSelectAll(!isSelectedAll)
    }

    return (
        <th className='BulkSelect position-relative'>
            <Checkbox disabled={loadingSend} indeterminate={!isSelectedAll && selectedItems.length > 0} onChange={_handleChange} checked={props.isSelectedAll}/>
        </th>
    )
}

export default BulkSelect
